import { Navigate, Outlet } from 'react-router-dom';
import { useAuth, useDeviceLock } from '@/hooks';
import { useAdminIdleTimeout } from '@/hooks/useAdminIdleTimeout';
import Layout from '@/components/layout/Layout';
import LoadingSpinner from '@/components/ui/LoadingSpinner';

export default function ProtectedRoute() {
  const { session, isLoading } = useAuth();
  const { locked } = useDeviceLock();
  useAdminIdleTimeout();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // PIN fast-switch lock: the session is still valid, but the app is locked to
  // the switch screen until someone re-authenticates with a PIN (or a password
  // login / clear-device). This is what makes idle-lock a real lock rather than
  // a redirect the Back button defeats. /switch lives under
  // StandaloneProtectedRoute, so it stays reachable while locked.
  if (locked) {
    return <Navigate to="/switch" replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}